import React, { useState } from 'react';
import BasePageComponent from '../../../components/base/BasePageComponent';
import AddEditForceUpdateModal from './AddEditForceUpdateModal';
import ForceUpdateCard from './ForceUpdateCard';

const ForceUpdatesPage = () => {
  const tableName = 'force_update_history';

  const keyMappings = {
    // id: 'ID',
    platform: 'Platform',
    existing_version: 'Version',
    mandatory_update_version: 'Mandatory Version',
    effective_date: 'Effective Date',
    last_modified_date: 'Last Modify Date',
    // updated_at: 'Updated At'
  };

  const tableHeaders = [
    // 'id',
    'platform', 
    'existing_version',
    'mandatory_update_version', 
    'last_modified_date', 
    'effective_date'
    // 'updated_at', 
  ];
  return (
    <BasePageComponent
      txt="Force Update"
      addItemComponent={AddEditForceUpdateModal}
      itemCardComponent={ForceUpdateCard}
      // itemCardListComponent={VIPLevelCardList}
      showToggleView={false}
      tableName={tableName}
      tableHeaders={tableHeaders}
      keyMappings={keyMappings}
      showPagination={true}
    />
  );
};

export default ForceUpdatesPage;
